// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"601":"5e714d66cf040d57","9316":"fc2f5e5291f31032"}[chunkId] + ".css";
};